export default "__VITE_ASSET__D_J5YCBq__ 100w";